import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PrivateModeService {

  isPrivateMode(): Promise<boolean> {
    return new Promise<boolean>(resolve => {
      const yes = () => resolve(true); // is in private mode
      const not = () => resolve(false); // not in private mode

      function detectChromeOpera(): boolean {
        const isChromeOpera = /(?=.*(opera|chrome)).*/i.test(navigator.userAgent) && navigator.storage?.estimate;
        if (isChromeOpera) {
          try {
            const prev = localStorage.length;
            localStorage.setItem('inPrivate', '0');
            const post  = localStorage.length;
            localStorage.removeItem('inPrivate');
            if (post > prev) {
              // localstorage is accesible
              not();
            }
            else if (post === prev) {
              yes();
            }
          }
          catch (e){
           yes();
          }
        }
        return !!isChromeOpera;
      }

      function detectFirefox(): boolean {
        const isMozillaFirefox = 'MozAppearance' in document.documentElement.style;
        if (isMozillaFirefox) {
          if (indexedDB == null) yes();
          else {
            const db = indexedDB.open('inPrivate');
            db.onsuccess = not;
            db.onerror = yes;
          }
        }
        return isMozillaFirefox;
      }

      function detectSafari(): boolean {
        //eslint-disable-next-line
        const isSafari = navigator.userAgent.match(/Version\/([0-9\._]+).*Safari/);
        if (isSafari) {
          const testLocalStorage = () => {
            try {
              if (localStorage.length) not();
              else {
                localStorage.setItem('inPrivate', '0');
                localStorage.removeItem('inPrivate');
                not();
              }
            } catch (_) {
              // Safari only enables cookie in private mode
              // if cookie is disabled, then all client side storage is disabled
              // if all client side storage is disabled, then there is no point
              // in using private mode
              navigator.cookieEnabled ? yes() : not();
            }
            return true;
          };

          const version = parseInt(isSafari[1], 10);
          if (version < 11) return testLocalStorage();
          try {
            (window as any).openDatabase(null, null, null, null);
            not();
          } catch (_) {
            yes();
          }
        }
        return !!isSafari;
      }

      // when a browser is detected, it runs tests for that browser
      // and skips pointless testing for other browsers.
      if (detectChromeOpera()) return;
      if (detectFirefox()) return;
      if (detectSafari()) return;

      // default navigation mode
      return not();
    });
  }


}
